module.exports = __webpack_public_path__ + "static/media/benzodiazepines.710689bc.svg";